module.exports = __webpack_public_path__ + "static/glass-mockup-holder-54ea980818723722da8806883b77bba2.webp";